"use strict";

var _classCallCheck = require("/var/jenkins_home/workspace/tingle.adede820-d9d0-11eb-831c-582d2d8e32fe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AccessTokenManager = function AccessTokenManager() {
  var _this = this;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    url: '',
    options: {}
  };

  _classCallCheck(this, AccessTokenManager);

  this.get = function () {
    if (_this.expiresAt > Date.now() && _this.cachedToken) {
      return _this.cachedToken;
    }

    _this.expiresAt = Infinity;
    _this.cachedToken = fetch(_this.url, _this.options).then(function (response) {
      if (response.ok) {
        return response.json().then(function (json) {
          _this.expiresAt = Date.now() + json.expires_in * 1000 * 0.9;
          return json.access_token;
        }).catch(function (error) {
          var out = {
            error: error,
            response: response
          };
          return Promise.reject(out);
        });
      }

      if (response.status === 401) {
        return Promise.resolve().then(function () {
          _this.expiresAt = 0;
          return;
        });
      }

      _this.cachedToken = undefined;
      _this.expiresAt = 0;
      var out = {
        error: null,
        response: response
      };
      return Promise.reject(out);
    });
    return _this.cachedToken;
  };

  this.clear = function () {
    _this.cachedToken = undefined;
    _this.expiresAt = 0;
  };

  this.url = props.url;
  this.options = Object.assign({}, props.options, {
    headers: Object.assign({
      Accept: 'application/json'
    }, props.options && props.options.headers || {})
  });
  this.cachedToken = undefined;
  this.expiresAt = 0;
};

AccessTokenManager.createUser = function (clientId) {
  return new AccessTokenManager({
    url: "https://generic.wg.spotify.com/creator-auth-proxy/v1/web/token?client_id=".concat(clientId),
    options: {
      credentials: 'include'
    }
  });
};

AccessTokenManager.createAnonymous = function (clientId) {
  return new AccessTokenManager({
    url: 'https://generic.wg.spotify.com/creator-auth-proxy/api/token',
    options: {
      method: 'POST',
      body: "client_id=".concat(clientId, "&grant_type=client_credentials")
    }
  });
};

exports.AccessTokenManager = AccessTokenManager;